/**
 * Generate FAQPage schema for FAQ pages and FAQ sections
 * @param {Array} faqs - Array of FAQ objects
 * @param {string} faqs[].question - The question text
 * @param {string} faqs[].answer - The answer text
 */
export const generateFAQSchema = (faqs) => {
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};
